import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import type { ILegendItem } from "app/components/React/Legends/legendsTypes";
import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";

import { BaseBarList } from "../components/shared/BaseBarList";
import { SharedLabelRow } from "../components/shared/SharedLabelRow";
import { BarWrapper } from "../components/shared/styledComponents";
import type { BaseBarItemWithColor, HorizontalBarItem } from "../types";

const StyledProgressBar = styled(ProgressBar)`
    border-radius: 2px;
`;

interface IHorizontalBarListProps {
    data: HorizontalBarItem[];
    legendItems: ILegendItem[];
}

const ProgressBarItemComponent: FC<{ item: HorizontalBarItem }> = ({ item }) => {
    const { label, value, progressBarItem, yoyChange } = item;
    return (
        <BarWrapper>
            <SharedLabelRow
                label={label}
                value={value}
                percentage={progressBarItem?.percentage}
                yoyChange={yoyChange}
            />
            {progressBarItem ? (
                <StyledProgressBar
                    width={progressBarItem.barFill}
                    height={16}
                    innerColor={progressBarItem.color}
                    backgroundColor={colorsPalettes.carbon[25]}
                />
            ) : null}
        </BarWrapper>
    );
};
const TotalItemComponent: FC<{ item: HorizontalBarItem }> = ({ item }) => {
    const { label, value, favicon } = item;
    return (
        <BarWrapper>
            <SharedLabelRow
                label={label}
                value={value}
                favicon={favicon}
                isHoverable={false}
            />
        </BarWrapper>
    );
};

const HorizontalBarList: FC<IHorizontalBarListProps> = ({ data, legendItems }) => {
    const renderBarItem = (item: BaseBarItemWithColor) => <ProgressBarItemComponent item={item} />;

    const renderTotalItem = (item: BaseBarItemWithColor) => <TotalItemComponent item={item} />;
    return (
        <BaseBarList
            data={data}
            legendItems={legendItems}
            renderBarItem={renderBarItem}
            renderTotalItem={renderTotalItem}
            showTotal={true}
        />
    );
};

export default HorizontalBarList;
